import Bids from "./Bids";

export default Bids;
